import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import LogoutIcon from "@mui/icons-material/Logout";
import RestaurantMenuRoundedIcon from "@mui/icons-material/RestaurantMenuRounded";
import config from "../../../config";
import { getUserRecipesPath } from "../../../utils/recipeRoutes";

const itemSx = {
  mx: 1.5,
  my: 0.25,
  px: 1.75,
  py: 1,
  borderRadius: 2,
  color: "surfaces.onDark",
  transition: "background-color .2s ease, transform .2s ease",
  "& .MuiListItemIcon-root": {
    color: "surfaces.onDark",
    opacity: 0.75,
    minWidth: 38,
    transition: "opacity .2s ease, color .2s ease",
  },
  "& .MuiListItemText-primary": {
    fontWeight: 500,
    fontSize: "0.95rem",
  },
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.08)",
    transform: "translateX(2px)",
    "& .MuiListItemIcon-root": { opacity: 1, color: "accent.main" },
  },
};

const logoutSx = {
  ...itemSx,
  mt: 1,
  "&:hover": {
    backgroundColor: "rgba(244,67,54,0.12)",
    transform: "translateX(2px)",
    "& .MuiListItemIcon-root": { opacity: 1, color: "#FF8A80" },
    "& .MuiListItemText-primary": { color: "#FF8A80" },
  },
};

export default function NavListAuthed({
  isAdmin,
  username,
  onNavigate,
  onLogout,
  onClose,
}) {
  const myRecipesPath = getUserRecipesPath(username);

  return (
    <List sx={{ py: 0 }}>
      {myRecipesPath !== "/recipes" && (
        <ListItemButton onClick={() => onNavigate(myRecipesPath)} sx={itemSx}>
          <ListItemIcon>
            <RestaurantMenuRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="Mina recept" />
        </ListItemButton>
      )}

      <ListItemButton onClick={() => onNavigate("/dashboard")} sx={itemSx}>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Profil" />
      </ListItemButton>

      {isAdmin && (
        <ListItemButton
          onClick={() => {
            const base = config.apiUrl.replace(/\/api\/?$/, "");
            window.open(`${base}admin/`, "_blank");
          }}
          sx={itemSx}
        >
          <ListItemIcon>
            <AdminPanelSettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Admin" />
        </ListItemButton>
      )}

      <ListItemButton
        onClick={() => {
          onClose?.();
          onLogout();
        }}
        sx={logoutSx}
      >
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText primary="Logga ut" />
      </ListItemButton>
    </List>
  );
}
